<div class="flex flex-col gap-9">
  <app-global-deliverables-list
    [getExistingDeliverablesCount]="getExistingDeliverablesCountForGlobal"
    [getExistingExecutionsCount]="getExistingExecutionsCountForGlobal"
    [getExistingKpisCount]="getExistingKpisCountForGlobal"
    [globalAndSharedCtaValues]="globalAndSharedCtaValues()"
    [hasGlobalBriefingNote]="hasGlobalBriefingNote()"
    (addDeliverablesForCta)="onAddDeliverablesClick([ALL_CREATORS_ID], $event, EDeliverableFlowStep.deliverable)"
    (addExecutionsForCta)="onAddDeliverablesClick([ALL_CREATORS_ID], $event, EDeliverableFlowStep.execution)"
    (addKpisForCta)="onAddDeliverablesClick([ALL_CREATORS_ID], $event, EDeliverableFlowStep.kpis)"
    (addGlobalBriefingNotes)="onOpenGlobalBriefingNotes()"
    (addGlobalDeliverables)="onAddDeliverablesClick([ALL_CREATORS_ID], null)"
    (copyCta)="copyCta($event)"
    (editCta)="onAddDeliverablesClick([ALL_CREATORS_ID], $event, EDeliverableFlowStep.review)"
    (editCtaGroup)="onAddDeliverablesClick([ALL_CREATORS_ID], $event, EDeliverableFlowStep.deliverable)"
    (removeCtaGlobally)="removeCtaGlobally($event)"
  />

  <app-campaign-form-creators-list
    [campaignCreatorsValue]="campaignCreatorsValue"
    [campaign]="campaign()"
    [ctasShareCountMap]="ctasShareCountMap()"
    [creatorHasCustomValueMap]="creatorHasCustomValueMap()"
    [getExistingDeliverablesCount]="getExistingDeliverablesCountForGlobal"
    [getExistingExecutionsCount]="getExistingExecutionsCountForGlobal"
    [getExistingKpisCount]="getExistingKpisCountForGlobal"
    [briefingNotes]="briefingNotes()"
    [newlyAddedCreatorIds]="newlyAddedCreatorIds()"
    (addCreatorClick)="onAddCreatorClick()"
    (editPayoutClick)="editCreatorById($event)"
    (deleteCreatorClick)="removeCreatorById($event)"
    (briefingNoteClick)="openCreatorBriefingNotesById($event)"
    (addIndividualGroupClick)="onAddDeliverablesClick([$event])"
    (addDeliverablesForCta)="onAddDeliverablesClick([$event.creatorId], $event.ctaId, $event.step, $event.creatorId)"
    (editCtaName)="
      onAddDeliverablesClick([$event.creatorId], $event.ctaId, EDeliverableFlowStep.review, $event.creatorId)
    "
    (editCtaGroup)="
      onAddDeliverablesClick([$event.creatorId], $event.ctaId, EDeliverableFlowStep.deliverable, $event.creatorId)
    "
    (removeCtaFromCreator)="removeCtaFromCreator($event.creatorId, $event.ctaId, $event.isAllCreators)"
    (copyCtaForCreator)="copyCtaForCreator($event.ctaId, $event.creatorId)"
    (copyCta)="copyCta($event)"
  />
</div>

<ng-template #customOption let-item>
  <div class="flex items-center gap-2 max-w-[300px]">
    <app-icon-badge [content]="item?.icon" [fallbackText]="item?.name" [size]="24" [iconSize]="24" [fontSize]="14" />
    <span class="whitespace-nowrap overflow-hidden text-ellipsis flex-1">{{ item?.name }}</span>
  </div>
</ng-template>

<ng-template #creatorWithoutCta>
  <div class="flex flex-1 gap-1 items-center justify-start">
    <app-icon src="icons/question-mark.svg" alt="arrow right" class="w-12 h-12" />
    <div class="flex items-center gap-2 text-sm font-bold">
      <span> {{ 'pages.campaignForm.sections.creatorsAndCtas.creatorWithoutCta' | translate }} </span>
    </div>
  </div>
</ng-template>
